import { atom, useAtom, useSetAtom } from "jotai";

export const modalAtom = atom(0);

const useLiveDay = () => {
  return useAtom(modalAtom);
};

export const useSetLiveDay = () => useSetAtom(modalAtom);

export default useLiveDay;
